import { EnvelopeIcon, PhoneIcon } from '@heroicons/react/24/solid';
import { formatPhoneNumber } from '@/utils';

export const HowInfo = ({ howInfo }: any) => {
  return (
    <section aria-labelledby='applicant-information-title'>
      <div className='bg-white shadow sm:rounded-lg'>
        <div className='py-5'>
          <div className='px-4 py-2 sm:px-6 border-l-4 border-primaryColor-normal'>
            <h2 id='applicant-information-title' className='m-0 text-lg leading-6 font-medium text-primaryColor-normal'>
              House of Worship Information
            </h2>
            <p className='mt-1 max-w-2xl text-sm text-gray-500'>Information about House of Worship</p>
          </div>
        </div>
        <div className='border-t border-gray-200 px-4 py-5 sm:px-6'>
          <dl className='grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2'>
            <div className='sm:col-span-1'>
              <dt className='text-sm font-medium text-gray-500'>House of Worship Name</dt>
              <dd className='mt-1 text-sm text-gray-900'>{howInfo?.name}</dd>
            </div>
            <div className='col-span-1'>
              <dt className='text-sm font-medium text-gray-500'>Website</dt>
              <dd className='mt-1 text-sm text-gray-900'>{howInfo?.website ? howInfo.website : 'Not Provided'}</dd>
            </div>
            <div className='col-span-1'>
              <dt className='text-sm font-medium text-gray-500'>House of Worship Address</dt>
              <dd className='mt-1 text-sm text-gray-900'>
                {howInfo?.address}, {howInfo?.city}, {howInfo?.state}, {howInfo?.zipCode}
              </dd>
            </div>
            <div className='sm:col-span-1'>
              <dt className='text-sm font-medium text-gray-500'>Clergy Leader</dt>
              <dd className='mt-1 text-sm text-gray-900 flex flex-col gap-1'>
                <span>{howInfo?.clergyLeader}</span>
                <span className='flex gap-2'>
                  <EnvelopeIcon className='h-5 w-5 text-neutralColor-normal' />
                  {howInfo?.email}
                </span>
                <span className='flex gap-2'>
                  <PhoneIcon className='h-5 w-5 text-neutralColor-normal' />
                  +1 {formatPhoneNumber(howInfo?.phone)}
                </span>
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </section>
  );
};
